import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { discogsAPI } from '../lib/api';
import SearchResults from './SearchResults';

export default function CatalogSearch({ onSuccess }) {
  const [catno, setCatno] = useState('');
  const [label, setLabel] = useState('');
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!catno.trim()) {
      toast.error('Please enter a catalog number');
      return;
    }

    setLoading(true);
    setResults([]);

    try {
      // Build search query
      let query = catno.trim();
      if (label.trim()) {
        query = `${label.trim()} ${query}`;
      }
      
      const res = await discogsAPI.search({ catno: catno.trim(), q: label.trim() || undefined });
      
      if (res.data.results?.length > 0) {
        setResults(res.data.results);
      } else {
        toast.error('No albums found with this catalog number');
      }
    } catch (err) {
      if (err.response?.status === 503) {
        toast.error('Discogs API not configured. Please add DISCOGS_TOKEN.');
      } else {
        toast.error('Search failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (results.length > 0) {
    return (
      <SearchResults
        results={results}
        onSelect={onSuccess}
        onBack={() => setResults([])}
      />
    );
  }

  return (
    <form onSubmit={handleSearch} className="space-y-4">
      <div>
        <Label htmlFor="catno">Catalog Number *</Label>
        <Input
          id="catno"
          value={catno}
          onChange={(e) => setCatno(e.target.value)}
          placeholder="e.g. CBS 32018"
          className="h-12 bg-secondary border-border font-mono"
          data-testid="catalog-number-input"
        />
      </div>
      
      <div>
        <Label htmlFor="label">Label (optional)</Label>
        <Input
          id="label"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          placeholder="e.g. CBS, Atlantic, Blue Note"
          className="h-12 bg-secondary border-border"
          data-testid="label-input"
        />
      </div>

      <Button
        type="submit"
        disabled={loading || !catno.trim()}
        className="w-full gap-2 bg-primary text-primary-foreground"
        data-testid="search-catalog-btn"
      >
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Search'}
      </Button>
    </form>
  );
}
